
import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
let baseURL = 'https://www.rakumart-2c.com:8080'

//客户问题商品列表
export const clientMondaiList = data => axios({
    url: baseURL + "/api/clientMondaiList",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
}
)

//客户提交处理结果 
export const clientDealResult = data => axios({
    url: baseURL + "/api/clientDealResult",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
}
)

//客户问题商品列表TAB统计 
export const clientMondaiListCount = data => axios({
    url: baseURL + "/api/clientMondaiListCount",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
}
)

// 客户问题商品列表
// export const clientMondaiList = data => Vue.prototype.postAxios(baseURL + "/api/clientMondaiList", data)
